<template>
  <main>
    <md-steppers md-active-step="apply" md-alternative md-linear>
      <md-step id="email" md-label="メール認証" v-if="!form.salesMode"></md-step>
      <md-step id="apply" md-label="必須事項の入力"></md-step>
      <md-step id="start" md-label="無料トライアルご利用開始"></md-step>
    </md-steppers>

    <!-- 通信中 -->
    <div v-if="sending" class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <md-card-header>
          <div class="md-title">トライアルを申し込む</div>
        </md-card-header>
        <md-card-content>
          <loading-spinner v-if="true"></loading-spinner>
        </md-card-content>
      </md-card>
    </div>

    <!-- トライアル申し込みフォーム -->
    <form v-else-if="verifyEmail" class="md-layout md-alignment-center" novalidate
          @submit.prevent="validateRequestTrial">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <md-card-header>
          <div class="md-title">トライアルを申し込む</div>
        </md-card-header>
        <md-card-content>
          <flash-message v-if="errorMessages.length" :errors="errorMessages"></flash-message>
          <!-- 法⼈名、支店名 -->
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-15 md-small-size-100"><label>法⼈名</label></div>
            <div class="md-layout-item md-size-45 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('corporation.name')">
                    <label>法⼈名</label>
                    <md-input v-model="form.corporation.name" :disabled="sending" required autocomplete="off"></md-input>
                    <span class="md-helper-text">例) 株式会社JON</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.name')">{{
                        getValidationResponseMessage('corporation.name')
                      }}</span>
                    <span class="md-error"
                          v-else-if="!$v.form.corporation.name.required">{{
                        errors.corporation.name.required
                      }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※法人名は省略せずにご入力ください。×(株)　〇株式会社<br>
                    ※個人のお客様はお手数ですが、法人名、ご担当者名ともお名前をご入力ください。
                  </span>
                </div>
              </div>
            </div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-field :class="getValidationClass('corporation.branch_name')">
                    <label>支店名</label>
                    <md-input v-model="form.corporation.branch_name" :disabled="sending" autocomplete="off"></md-input>
                    <span class="md-helper-text">例) 上野オフィス、上野支店</span>
                    <span class="md-error"
                          v-if="getValidationResponseMessage('corporation.branch_name')">{{
                        getValidationResponseMessage('corporation.branch_name')
                      }}</span>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item">
                  <span class="md-caption">
                    ※支店名等がある場合は、必ずご入力ください。
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- ご担当者名-->
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-15 md-small-size-100"><label>ご担当者名</label></div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field :class="getValidationClass('account.last_name')">
                <label>姓</label>
                <md-input v-model="form.account.last_name" :disabled="sending" required autocomplete="off"></md-input>
                <span class="md-helper-text">例) JON</span>
                <span class="md-error"
                      v-if="getValidationResponseMessage('account.last_name')">{{
                    getValidationResponseMessage('account.last_name')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.account.last_name.required">{{ errors.account.last_name.required }}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-size-25 md-small-size-100">
              <md-field :class="getValidationClass('account.first_name')">
                <label>名</label>
                <md-input v-model="form.account.first_name" :disabled="sending" required autocomplete="off"></md-input>
                <span class="md-helper-text">例) 太郎</span>
                <span class="md-error"
                      v-if="getValidationResponseMessage('account.first_name')">{{
                    getValidationResponseMessage('account.first_name')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.account.first_name.required">{{ errors.account.first_name.required }}</span>
              </md-field>
            </div>
          </div>

          <!-- ご連絡先-->
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-15 md-small-size-100"><label>ご連絡先</label></div>
            <div class="md-layout-item md-size-45 md-small-size-100">
              <md-field :class="getValidationClass('corporation.email')">
                <label>メールアドレス</label>
                <md-input name="mail" v-model="form.corporation.email" required
                          autocomplete="off"
                          :placeholder="(!form.salesMode ? '例）jontaro@jon.co.jp' : '')"
                          :disabled="!form.salesMode"/>
                <span class="md-helper-text">例) jontaro@jon.co.jp</span>
                <span class="md-error"
                      v-if="getValidationResponseMessage('corporation.email')">{{
                    getValidationResponseMessage('corporation.email')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.corporation.email.required">{{ errors.corporation.email.required }}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-field :class="getValidationClass('corporation.tel')">
                <label>電話番号</label>
                <md-input :disabled="sending" name="phone" required autocomplete="off" v-model="form.corporation.tel"/>
                <span class="md-helper-text">例) 0332691220</span>
                <span class="md-error"
                      v-if="getValidationResponseMessage('corporation.tel')">{{
                    getValidationResponseMessage('corporation.tel')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.corporation.tel.required">{{ errors.corporation.tel.required }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.corporation.tel.numeric">{{ errors.corporation.tel.numeric }}</span>
              </md-field>
            </div>
          </div>

          <!-- その他-->
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-15 md-small-size-100"><label>その他</label></div>
            <div class="md-layout-item md-size-30 md-small-size-100">
              <md-field :class="getValidationClass('contract.reason')">
                <label>申し込みのきっかけ</label>
                <md-select v-model="form.contract.reason" :disabled="sending" required>
                  <md-option v-for="(reason,index) in contractReason" :value="reason"
                             :key="'reason-' + index">
                    {{ reason }}
                  </md-option>
                </md-select>
              </md-field>
            </div>
          </div>

          <!-- JON担当者-->
          <div class="md-layout md-gutter" v-if="form.salesMode">
            <div class="md-layout-item md-size-15 md-small-size-100"><label>JON担当者</label></div>
            <div class="md-layout-item md-size-45 md-small-size-100">
              <md-field :class="getValidationClass('jon.email')">
                <label>メールアドレス</label>
                <md-input :disabled="sending" name="mail" v-model="form.jon.email" required/>
                <span class="md-error"
                      v-if="getValidationResponseMessage('jon.email')">{{
                    getValidationResponseMessage('jon.email')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.jon.email.requiredIf">{{ errors.jon.email.requiredIf }}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-size-40 md-small-size-100">
              <md-field :class="getValidationClass('jon.name')">
                <label>営業担当者</label>
                <md-input :disabled="sending" name="name" required v-model="form.jon.name"/>
                <span class="md-error"
                      v-if="getValidationResponseMessage('jon.name')">{{
                    getValidationResponseMessage('jon.name')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.jon.name.requiredIf">{{ errors.jon.name.requiredIf }}</span>
              </md-field>
            </div>
          </div>

          <div class="md-layout md-gutter" v-if="!form.salesMode">
            <div class="md-layout-item md-size-15 md-small-size-100">利用規約の確認</div>
            <div class="md-layout-item md-size-85 md-small-size-100">
              <md-button :disabled="sending" @click="openTerms" class="md-primary md-raised">
                <md-icon>list_alt</md-icon>
                <span>シカクマップ 利用規約</span>
              </md-button>
            </div>
          </div>
          <div class="md-layout md-gutter" v-if="!form.salesMode">
            <div class="md-layout-item md-size-15 md-small-size-100"></div>
            <div class="md-layout-item md-size-85 md-small-size-100">
              <md-checkbox id="checkAccept" class="md-primary" v-model="form.apply"
                           :disabled="sending || !isReadTerms">
                上記利用規約に同意します
              </md-checkbox>
              <flash-message v-if="getValidationResponseMessage('apply')"
                             :errors="[getValidationResponseMessage('apply')]"></flash-message>
            </div>
          </div>
          <div class="md-layout md-gutter" v-if="!form.salesMode">
            <div class="md-layout-item md-size-15 md-small-size-100"></div>
            <div class="md-layout-item">
              <p class="md-caption">ご入力いただいた個人情報の取り扱い詳細は<a href="https://www.jon.co.jp/privacy/" target="_blank"
                                                           rel="noopener">プライバシーポリシー</a>をご覧ください。<br>
                トライアルの申し込みをもって、これにご同意いただいたものとみなします。</p>
            </div>
          </div>
        </md-card-content>

        <md-card-actions>
          <div class=" md-layout md-layout-item md-alignment-center md-small-size-100">
            <md-button type="submit" class="md-raised md-primary md-apply" :disabled="sending">
              <md-icon>check</md-icon>
              <span>トライアルを申し込む</span>
            </md-button>
          </div>
        </md-card-actions>
      </md-card>
    </form>

    <!-- 認証コードエラー -->
    <div v-else-if="!verifyEmail" class="md-layout md-alignment-center">
      <md-card class="md-layout-item md-size-90 md-small-size-100">
        <md-card-header>
          <div class="md-title">トライアルを申し込む</div>
        </md-card-header>

        <md-card-content>
          <div class="md-layout md-alignment-center">
            <div class="md-layout-item md-size-90 md-small-size-100">
              <flash-message v-if="getValidationResponseMessage('code')"
                             :errors="[getValidationResponseMessage('code')]"></flash-message>
              <p>申し込みフォームのURLが確認できませんでした。</p>
              <p>有効期限が切れているか、すでに申し込み済みの可能性があります。<br>
                お手数ですが、再度「
                <router-link :to="{ name: 'TrialEmail' }"><a>無料トライアルのお申し込み</a></router-link>
                」より登録を行ってください
              </p>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </main>
</template>

<script>
import CommonMixin                            from '../../mixins/commonMixin';
import {apiClient, apiList}                   from '../../modules/apiClient';
import Validation                             from '../../modules/validation';
import Common                                 from '../../modules/common';
import FlashMessage                           from '../../components/FlashMessage';
import LoadingSpinner                         from "../../components/LoadingSpinner";
import {validationMixin}                      from 'vuelidate';
import {email, numeric, required, requiredIf} from 'vuelidate/lib/validators';

export default {
  name      : "TrialApply",
  components: {FlashMessage, LoadingSpinner},
  mixins    : [validationMixin, CommonMixin],
  data      : () => ({
    verifyEmail   : false,
    sending       : false,
    isReadTerms   : false,
    form          : {
      corporation: {
        name       : null,
        branch_name: null,
        email      : null,
        tel        : null,
      },
      account    : {
        last_name : '',
        first_name: '',
      },
      jon        : {
        email: null,
        name : null,
      },
      contract   : {
        reason: Common.contractReason[0],
      },
      apply      : false,
      salesMode  : false,
    },
    contractReason: Common.contractReason,
    errors        : {
      corporation: {
        name : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationName'),
        },
        email: {
          required: Validation.errorMessage(Validation.rules.required, 'corporationEmail'),
          email,
        },
        tel  : {
          required: Validation.errorMessage(Validation.rules.required, 'corporationTel'),
          numeric : Validation.errorMessage(Validation.rules.numeric, 'corporationTel'),
        },
      },
      account    : {
        last_name : {
          required: Validation.errorMessage(Validation.rules.required, 'accountLastName'),
        },
        first_name: {
          required: Validation.errorMessage(Validation.rules.required, 'accountFirstName'),
        },
      },
      jon        : {
        email: {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'jonEmail'),
          email,
        },
        name : {
          requiredIf: Validation.errorMessage(Validation.rules.requiredIf, 'jonName'),
        },
      },
      apply      : {
        required: Validation.errorMessage(Validation.rules.required, 'apply'),
      },
    },
  }),
  validations() {
    return {
      form: {
        corporation: {
          name : {
            required,
          },
          email: {
            required,
            email,
          },
          tel  : {
            numeric,
            required,
          },
        },
        account    : {
          last_name : {
            required,
          },
          first_name: {
            required,
          },
        },
        jon        : {
          email: {
            requiredIf: requiredIf(() => {
              return this.form.salesMode;
            }),
            email,
          },
          name : {
            requiredIf: requiredIf(() => {
              return this.form.salesMode;
            }),
          }
        },
        contract   : {},
        apply      : {
          required,
        },
      },
    };
  },
  mounted: function () {
    this.form.salesMode = Common.sales.filter((sale) => {
      return this.$route.path.indexOf(sale) !== -1;
    }).length > 0;
    if (this.form.salesMode) {
      // 営業担当者によるトライアル代理申請の流れ（メールアドレスは認証済み、利用規約を閲覧済みとする）
      this.verifyEmail          = true;
      this.isReadTerms          = true;
      this.contractReason       = Common.contractReasonForSales;
      this.form.apply           = true;
      this.form.contract.reason = Common.contractReasonForSales[0];
    } else {
      // 通常のトライアル申し込みの流れ
      this.getVerifyEmail();
    }
  },
  updated() {
    let selectorInvalid = this.$el.querySelector(".md-invalid");
    if (selectorInvalid !== null) {
      this.scrollToSelector(selectorInvalid);
    }
    let selectorFlashError = this.$el.querySelector(".flash-error-message");
    if (selectorFlashError !== null) {
      this.scrollToSelector(selectorFlashError);
    }
  },
  methods: {
    /**
     * 認証コードによるメール認証
     */
    getVerifyEmail() {
      this.sending = true;
      apiClient.get(apiList.verify_email, {
        params: {
          code: this.$route.query.vid,
        }
      })
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            this.verifyEmail            = true;
            this.form.corporation.email = response.data.email;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
          });
    },
    /**
     * トライアルの申し込み
     */
    sendRequestTrial() {
      this.sending = true;
      apiClient.post(apiList.application.trial, this.form)
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return
            }
            localStorage.setItem(Common.localStorageKeys.requestSuccess, 'true');

            // トライアル申し込み完了へ遷移したことをGTMのdataLayerに通知する
            dataLayer.push({
              event: 'TrialRegistrationComplete',
            });

            this.$router.replace({name: 'TrialStart'});
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
            this.sending = false;
            this.$v.$reset()
          });
    },
    /**
     * フォーム入力内容をクリアする
     */
    clearForm() {
      this.$v.$touch();
      this.errorMessages  = [];
      this.successMessage = null;
    },
    /**
     * バリデーション
     */
    validateRequestTrial() {
      this.clearForm();
      if (this.$v.$invalid) {
        // Validate false
        let selectorInvalid = this.$el.querySelector(".md-invalid");
        if (selectorInvalid !== null) {
          this.scrollToSelector(selectorInvalid);
        }
      } else if (this.form.apply === false) {
        this.validateResponse.push({
          target : 'apply',
          message: Common.messages.requestTrial.acceptTermMessage
        });
      } else {
        this.sendRequestTrial();
      }
    },
    /**
     * 利用規約を開く
     */
    openTerms() {
      window.open('/terms', '_blank');
      this.isReadTerms = true;
    },
  },
  watch  : {
    "form.corporation.tel": function (value) {
      if (!value) {
        this.form.corporation.tel = '';
        return false;
      }
      this.form.corporation.tel = value.match(/\d/ig) ? value.match(/\d/ig).join('') : '';
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components";

.md-steppers {
  height: 104px;
}

.md-stepper {
  padding: 0;
}

.md-card {
  margin-top: 20px;
  margin-bottom: 40px;
}

.md-apply {
  margin-left: 0;
  margin-bottom: 50px;
}
</style>
